import React, { ReactNode } from 'react';
import styles from './TrialOption.module.css';

interface TrialOptionCardProps {
  children: ReactNode;
}

const TrialOptionCard: React.FC<TrialOptionCardProps> = ({ children }) => {
  return (
    <div className={styles.optionCard}>
      {children}
    </div>
  );
};

export default TrialOptionCard; 